/**
 * Resolve human-readable venue org label for checkout surfaces (G6).
 * Falls back to tenantCode only when no branding name is cached yet.
 */
export function resolveCustomerTenantDisplayName(input: {
  readonly tenantCode: string;
  readonly membershipTenantName?: string | null;
  readonly publicTenantName?: string | null;
}): string {
  const fromMembership = input.membershipTenantName?.trim() ?? '';
  if (fromMembership.length > 0) {
    return fromMembership;
  }
  const fromPublic = input.publicTenantName?.trim() ?? '';
  if (fromPublic.length > 0) {
    return fromPublic;
  }
  return input.tenantCode;
}
